exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".partial-header.navbar .bell-badge[data-v-b55c9b82]{margin-left:-9px}", "", {"version":3,"sources":["/./src/components/app/itens_menu/GeneralNotifications.vue"],"names":[],"mappings":"AACA,oDACE,gBAAmB,CACpB","file":"GeneralNotifications.vue","sourcesContent":["\n.partial-header.navbar .bell-badge[data-v-b55c9b82] {\n  margin-left: -09px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-b55c9b82&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/itens_menu/GeneralNotifications.vue
// module id = 616
// module chunks = 2